import { Naslov } from "../../../index";
import { useContext } from "react";
import { Context } from "../../../../context";

const Index = () => {
  const [data] = useContext(Context);
  const { user } = data;
  const { preferred_username } = user;
  return (
    <>
      <Naslov label={"Korisnik (User)"} />
      <span>{preferred_username}</span>
    </>
  );
};

export default Index;
